const totalCostByWeightAndZoneResponseToTotalCostByWeightAndZoneObject = (response) => {
    return {
        weight: response.weight,
        zone: response.zone,
        cost: response.cost
    };
};

export { totalCostByWeightAndZoneResponseToTotalCostByWeightAndZoneObject };